<template>
  <div class="flex flex-col items-center justify-center px-10">
    <div>
      <Icon class="mx-auto mb-9 text-center text-primary" name="Sad" size="56px" />
      <h2 class="text-center">Loading failure</h2>
      <p class="mt-5 mb-10 text-center">Check your internet connection and try again.</p>
      <Button class="mx-auto mt-10 w-fit px-9" @click="reloadPage">Refresh page</Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import Button from "./Button.vue";
import Icon from "./Icon.vue";

function reloadPage() {
  window.location.reload();
}
</script>
